import { Avatar, IconButton } from "@mui/material";
import type { UserInfo } from "firebase/auth";
import type { MouseEvent } from "react";

export function AppBarAvatar(props: {
  onClick: (event: MouseEvent) => void;
  openMenu: boolean;
  userInfo: UserInfo | null;
}) {
  return (
    <IconButton
      onClick={props.onClick}
      size="small"
      aria-controls={props.openMenu ? "account-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={props.openMenu ? "true" : undefined}
      sx={{ p: 0 }}
    >
      <Avatar
        src={props.userInfo?.photoURL ?? undefined}
        sx={{
          width: 34,
          height: 34,
          bgcolor: "#ffd54f",
          color: "#fff",
          fontSize: "0.875rem",
          fontWeight: "bold",
          transition: "0.2s",
          "&:hover": { opacity: 0.8 },
        }}
      >
        {props.userInfo?.displayName?.substring(0, 2)}
      </Avatar>
    </IconButton>
  );
}
